<template>
  <div class="modals">
    <div class="modal create-proposal-modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Create Proposal <span class="tag is-primary is-medium" v-if="$store.contracts.VOTING_VAULTS[$store.walletAddress] && $store.contracts.VOTING_VAULTS[$store.walletAddress].length > 0">Using Vault</span></p>
          <button @click="$emit('close')" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Title</label>
            <div class="control">
              <input v-model="proposalTitle" class="input" type="text" placeholder="Your Awesome Proposal">
            </div>
            <p class="help"></p>
          </div>
          <div class="field">
            <label class="description-url label is-flex is-align-items-center">
              Description URL
            </label>
            <div class="control">
              <input
                v-model="proposalDescriptionURL"
                v-on:input='fetchContent'
                class="input"
                type="text"
                placeholder="https://ipfs.io/ipfs/..."
              >
            </div>
            <p class="help has-text-danger">{{ formatWizardError }}</p>
          </div>
          <div class="field">
            <label class="label">
              Description Hash
              <transition
                enter-active-class="animate__animated animate__fadeIn fast"
                leave-active-class="animate__animated animate__fadeOut fast"
              >
                <div v-if="networkLoading" class="loader is-inline-block is-primary"></div>
              </transition>
            </label>
            <div class="control">
              <input v-model="proposalDescriptionHash" disabled="disabled" class="input" type="text">
            </div>
            <p class="help has-text-danger"></p>
          </div>
          <div class="field">
<!--            <label class="label">Proposal Lambda</label>-->
          </div>
          <div class="field">
            <div class="tabs is-toggle is-centered">
              <ul>
                <li :class="{'is-active': propsalWizardMode}">
                  <a @click="propsalWizardMode = true">
                    <span>Proposal Lambda Wizard</span>
                  </a>
                </li>
                <li :class="{'is-active': !propsalWizardMode}">
                  <a @click="propsalWizardMode = false">
                    <span>Custom Proposal Lambda</span>
                  </a>
                </li>
              </ul>
            </div>

            <div class="control">
              <michelson-editor
                v-if="!propsalWizardMode"
                @editor-change="proposalMichelson = $event"
                :read-only="false"
              />
              <create-proposal-wizard
                @update-proposal="proposalMichelson = $event"
                @default-changed="propsalWizardModeValueChanged = $event"
                v-else />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <button @click="$emit('close')" class="button">Cancel</button>
          <button @click="previewModalActive = true" class="button is-primary" :disabled="shouldPreventSending || proposalDescriptionContent === null">Preview Proposal</button>
        </footer>
      </div>
    </div>

    <transition
      enter-active-class="animate__animated animate__fadeIn fast"
      leave-active-class="animate__animated animate__fadeOut fast"
    >
      <div v-if="previewModalActive" :class="{'is-active': previewModalActive}" class="modal preview-modal">
        <div @click="previewModalActive = false" class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ proposalTitle }}</p>
            <button @click="previewModalActive = false" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">
            <div class="content" v-html="proposalDescriptionContent"></div>
            <michelson-editor
              :michelson-raw="proposalMichelson"
              :read-only="true"
            />
          </section>
          <footer class="modal-card-foot is-justify-content-flex-end">
            <button @click="previewModalActive = false" class="button">Close Preview</button>
            <button :class="{'is-loading': txSending}" @click="submitProposal" :disabled="shouldPreventSending" class="button is-primary">Submit Proposal</button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import MichelsonEditor from "@/components/MichelsonEditor";
import {Parser} from "@taquito/michel-codec";
import CreateProposalWizard from "@/components/CreateProposalWizard";

export default {
  name: 'CreateProposalModal',
  components: {CreateProposalWizard, MichelsonEditor},
  props: ['shown'],
  data(){
    return {
      proposalTitle: null,
      proposalDescriptionURL: null,
      proposalDescriptionHash: null,
      lambdaCode: null,
      networkLoading: false,
      wizardError: null,
      proposalMichelson: null,
      txSending: false,
      proposalDescriptionContent: null,
      previewModalActive: false,
      propsalWizardMode: true,
      propsalWizardModeValueChanged: false,
      wizardMichelson: ''
    }
  },
  methods: {
    async submitProposal(){
      this.txSending = true
      try {
        const daoContract = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO)
        const kdaoTokenContract = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO_TOKEN)

        const daoStorage = await daoContract.storage()

        const lockupVaultAddress = this.$store.contracts.VOTING_VAULTS[this.$store.walletAddress]

        let sendResult
        if (lockupVaultAddress !== undefined){
          const lockupVaultContract = await this.$store.tezosToolkit.wallet.at(lockupVaultAddress)
          sendResult = await lockupVaultContract.methods.propose(
            daoStorage.governanceParameters.escrowAmount,
            this.proposalTitle,
            this.proposalDescriptionURL,
            this.proposalDescriptionHash,
            this.proposalMichelsonConverted
          ).send()
        } else {
          sendResult = await this.$store.tezosToolkit.wallet.batch([])
            .withContractCall(kdaoTokenContract.methods.approve(this.$store.contracts.DAO, this.$store.daoParameters.governanceParameters.escrowAmount))
            .withContractCall(
              daoContract.methods.propose(
                this.proposalTitle,
                this.proposalDescriptionURL,
                this.proposalDescriptionHash,
                this.proposalMichelsonConverted
              )
            )
            .send()
        }

        this.$eventBus.$emit('tx-submitted', sendResult)
        await sendResult.confirmation(1)

        this.$emit('close')

        this.$store.daoParameters = null
        this.$eventBus.$emit('update-dao-info')
      } catch (e){
        console.log(e)
      } finally {
        this.$eventBus.$emit('tx-finished')
        this.txSending = false
      }
    },
    async hashData(message) {
      const msgUint8 = new TextEncoder().encode(message)
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    },
    async fetchContent(){
      this.wizardError = null
      this.proposalDescriptionHash = null
      if (this.proposalDescriptionURL.startsWith('https://')) {
        try {
          this.networkLoading = true
          const response = await axios.get(this.proposalDescriptionURL)
          this.proposalDescriptionHash = await this.hashData(response.data)
          this.proposalDescriptionContent = this.$store.markdown(response.data)
        } catch (e) {
          this.wizardError = e
        } finally {
          this.networkLoading = false
        }
      }
    },
    michelsonIsValid(text){
      try {
        // Try to parse the michelson to just check basic validity.
        new Parser().parseMichelineExpression(text)
        return true
      } catch (e) {
        console.log("Error parsing Michelson", e)
        return false
      }
    },
  },
  computed:{
    formatWizardError(){
      if (this.wizardError){
        return "Error: Could not fetch description content! Check the console for a detailed error and try again."
      } else {
        return ''
      }
    },
    proposalMichelsonConverted(){
      const p = new Parser()
      const data = p.parseMichelineExpression(this.proposalMichelson)
      return JSON.parse(JSON.stringify(data))
    },
    shouldPreventSending(){
      return this.txSending ||
             this.wizardError !== null ||
             (this.propsalWizardMode && this.propsalWizardModeValueChanged === false) ||
             (this.proposalTitle === null || this.proposalTitle.length === 0) ||
             (this.proposalDescriptionURL === null || !this.proposalDescriptionURL.startsWith('https://')) ||
             (this.proposalDescriptionHash === null) ||
             (this.proposalMichelson === null || this.proposalMichelson.length === 0 || !this.michelsonIsValid(this.proposalMichelson))
    }
  },
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.modals{
  position: relative;
  z-index: 40;
  .preview-modal{
    .modal-card {
      width: 66vw;
      @include until($tablet) {
        width: 100vw;
      }
    }
  }
  .create-proposal-modal{
    .modal-card{
      width: 75vw;
      @include until($tablet){
        width: 100vw;
      }
    }
    div.is-outlined{
      border: 2px solid $light-grey;
      border-radius: 5px;
      padding: 1rem;
    }
    .proposal-wizard{
      border: 2px solid $light-grey;
      border-radius: 5px;
      padding: 1rem;
    }
    .label.description-url{
      .loader{
        margin-left: .5rem;
      }
    }
  }
}
</style>
